<img [src]="src" [ngClass]="class">
<!-- <object [data]="src" class="blue"></object> -->
